import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import {
  listaContendientes,
  filteredContendientes,
  listaContendientesLicencia,
  listaContendientesRenuncia,
  listaContendientesFunciones,
  getallDocumentosAcuerdos_ReeleccionConsecutiva,
  configuracionSistema,
} from '../operations/query';
import gql from 'graphql-tag';
import copy from 'fast-copy';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ContendientesService {
  contendientes: any;
  constructor(private http: HttpClient,private apollo: Apollo) {}

  
  getLeyendaSuperior() {
    const url =
    'https://micrositios.diputados.gob.mx:4001/graphql?query={getLeyendaSuperior{LeyendaSuperior}}';
    return this.http.get<any>(url);
  }
  // Configuración para este Sistema
  configuracionSistema() {
    return this.apollo
      .watchQuery({
        query: configuracionSistema,
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          return result.data.configuracionContendientes23;
        })
      );
  }
  searchPosts(
    keyWord: string,
    fullText: string,
    files: Boolean,
    catalog: Boolean
  ) {
    return this.apollo.watchQuery<any>({
      query: gql`
          {
            filterContendientes23(KeyWord: "${keyWord}", FullText: "${fullText}", Files: ${files}, Catalog: ${catalog}) {
              Oid
              NombreDiputado
              Numero
              FechaRecepcion
              EntidadFederativa
              CorreoFisico
              Hora
              Folio
              GrupoParlamentario
              DistritoCircuns
              Tipo
              NombreArchivo
              TipoEleccion
              EnFunciones
              ArchivoB64
              Enlace
              Notas
              Id
            }
          }
        `,
    });
  }
  // Lista de los contendientes
  getContendientes(skip: boolean = false) {
    return this.apollo
      .watchQuery({
        query: listaContendientes,
        variables: {
          skip,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          result.data.allContendientes23.forEach((element: any) => {
            const myData = copy(element);
            myData.Tipo = myData.NombreArchivo
              ? myData.NombreArchivo.split('.')[1]
              : myData.NombreArchivo;
            element = myData;
            return element;
          });
          return result.data.allContendientes23;
        })
      );
  }
  // Lista de los contendientes
  getContendientesRenuncia(skip: boolean = false) {
    return this.apollo
      .watchQuery({
        query: listaContendientesRenuncia,
        variables: {
          skip,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          result.data.allContendientesRenuncia23.forEach((element: any) => {
            const myData = copy(element);
            myData.Tipo = myData.NombreArchivo
              ? myData.NombreArchivo.split('.')[1]
              : myData.NombreArchivo;
            element = myData;
            return element;
          });
          return result.data.allContendientesRenuncia23;
        })
      );
  }
  // Lista de los contendientes
  getContendientesLicencia(skip: boolean = false) {
    return this.apollo
      .watchQuery({
        query: listaContendientesLicencia,
        variables: {
          skip,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          result.data.allContendientesLicencia23.forEach((element: any) => {
            const myData = copy(element);
            myData.Tipo = myData.NombreArchivo
              ? myData.NombreArchivo.split('.')[1]
              : myData.NombreArchivo;
            element = myData;
            return element;
          });
          return result.data.allContendientesLicencia23;
        })
      );
  }
  // Lista de los contendientes
  getContendientesFunciones(skip: boolean = false) {
    return this.apollo
      .watchQuery({
        query: listaContendientesFunciones,
        variables: {
          skip,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          result.data.allContendientesFunciones23.forEach((element: any) => {
            const myData = copy(element);
            myData.Tipo = myData.NombreArchivo
              ? myData.NombreArchivo.split('.')[1]
              : myData.NombreArchivo;
            element = myData;
            return element;
          });
          return result.data.allContendientesFunciones23;
        })
      );
  }
  // Lista de los contendientes filtrados
  getContendientesFilter(keyWord: string) {
    return this.apollo
      .watchQuery({
        query: filteredContendientes,
        variables: {
          keyWord,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          // console.log('arph', result);
          result.data.filterContendientes23.forEach((element: any) => {
            const myData = copy(element);
            myData.Tipo = myData.NombreArchivo
              ? myData.NombreArchivo.split('.')[1]
              : myData.NombreArchivo;
            element = myData;
            return element;
          });

          return result.data.filterContendientes23;
        })
      );
  }
  getContendiente(skip: boolean = false, oid: string = '') {
    // console.log('Contendiente');
    // console.log(listaContendientes);
    return this.apollo
      .watchQuery<any>({
        query: gql`
        query listaContendientes {
        getContendiente23(Oid: "${oid}") {
          Oid
          NombreDiputado
          Enlace
          Numero
          FechaRecepcion
          EntidadFederativa
          CorreoFisico
          Hora
          Folio
          GrupoParlamentario
          DistritoCircuns
          Tipo
          NombreArchivo
          TipoEleccion
          EnFunciones
          Notas
          ArchivoB64
          ArchivoB641
          ArchivoB642
          ArchivoB643
        }
      }
      `,
        variables: {
          skip,
          oid,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          // console.log('result');
          // console.log(result);
          return result.data.getContendiente23;
        })
      );
  }
  getDocContendiente(skip: boolean = false, oid: string = '') {
    // console.log('Contendiente');
    // console.log(listaContendientes);
    return this.apollo
      .watchQuery<any>({
        query: gql`
        query getContendiente {
        getDocContendiente23(Oid: "${oid}") {
          Oid
          NombreDiputado
          Enlace
          Numero
          FechaRecepcion
          EntidadFederativa
          CorreoFisico
          Hora
          Folio
          GrupoParlamentario
          DistritoCircuns
          Tipo
          NombreArchivo
          TipoEleccion
          EnFunciones
          Notas
          ArchivoB64
          SFTPDocumento1
          SFTPDocumento2
        }
      }
      `,
        variables: {
          skip,
          oid,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          return result.data.getDocContendiente23;
        })
      );
  }

  getallDocumentosAcuerdos_ReeleccionConsecutiva() {
    
    return this.apollo
      .watchQuery({
        query: getallDocumentosAcuerdos_ReeleccionConsecutiva,
        variables: {
          
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result: any) => {
          // console.log('resultado', result);
          // result.data.allDocumentosAcuerdos_ReeleccionConsecutiva.forEach((element: any) => {
          //   // const myData = copy(element);
          //   // myData.Tipo = myData.NombreArchivo
          //   //   ? myData.NombreArchivo.split('.')[1]
          //   //   : myData.NombreArchivo;
          //   // element = myData;
          //   return element;
          // });
          return result.data.allDocumentosAcuerdos_ReeleccionConsecutiva23;
        })
      );
  }
}
